export default "__VITE_ASSET__fe5Guz3A__"